import { NgModule } from '@angular/core';
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { AppRoutingModule } from "@spartacus/storefront";
import { FooterModule } from './spartacus/custom-feature/common/components/footer/footer.module';
import { CustomFeatureModule } from './spartacus/custom-feature/custom-feature.module';
import { SpartacusModule } from './spartacus/spartacus.module';

@NgModule({
  imports: [
    StoreModule.forRoot({}),
    AppRoutingModule,
    EffectsModule.forRoot([]),
    SpartacusModule,
    CustomFeatureModule,
    FooterModule
  ]
})
export class AppModule { }
